export const SUPER_USER = 'Super User';
export const PROJECT_ADMIN = 'Project Admin';
export const PROJECT_CONTRIBUTOR = 'Project Contributor';
export const VISITOR = 'Visitor';
